export default __webpack_public_path__ + "static/media/money-back@3x.a040e971.png";